/** @internal */
export class Progress {
    lengthComputable;
    total;
    _onProgress;
    _unprocessedTasks;
    _processingTasks;
    _endedTaskNames;
    _endedTasksTotal;
    constructor(lengthComputable, tasks, onProgress) {
        this.lengthComputable = lengthComputable;
        let total = 0;
        for (let i = 0; i < tasks.length; ++i) {
            total += tasks[i].cost;
        }
        this.total = total;
        this._onProgress = onProgress;
        const unprocessedTasks = this._unprocessedTasks = new Map();
        for (let i = 0; i < tasks.length; ++i) {
            if (unprocessedTasks.has(tasks[i].name)) {
                throw new Error(`Duplicated task name: ${tasks[i].name}`);
            }
            unprocessedTasks.set(tasks[i].name, tasks[i]);
        }
        this._processingTasks = new Map();
        this._endedTaskNames = new Set();
        this._endedTasksTotal = 0;
    }
    _getTaskState(taskName) {
        let taskState = this._processingTasks.get(taskName);
        if (taskState === undefined) {
            const task = this._unprocessedTasks.get(taskName);
            if (task === undefined) {
                if (!this._endedTaskNames.has(taskName)) {
                    throw new Error(`Task not found: ${taskName}`);
                }
                else
                    return null;
            }
            taskState = {
                name: task.name,
                cost: task.cost,
                progress: 0
            };
            this._processingTasks.set(taskName, taskState);
            this._unprocessedTasks.delete(taskName);
        }
        return taskState;
    }
    processTask(taskName, cost) {
        const taskState = this._getTaskState(taskName);
        if (taskState === null)
            return;
        taskState.progress += cost;
        if (taskState.progress >= taskState.cost) {
            this._processingTasks.delete(taskName);
            this._endedTaskNames.add(taskName);
            this._endedTasksTotal += taskState.cost;
        }
    }
    setTaskProgress(taskName, progress) {
        const taskState = this._getTaskState(taskName);
        if (taskState === null)
            return false;
        taskState.progress = progress;
        if (taskState.progress >= taskState.cost) {
            this._processingTasks.delete(taskName);
            this._endedTaskNames.add(taskName);
            this._endedTasksTotal += taskState.cost;
        }
        return true;
    }
    setTaskProgressRatio(taskName, ratio, useFloor) {
        const taskState = this._getTaskState(taskName);
        if (taskState === null)
            return false;
        taskState.progress = useFloor
            ? Math.floor(taskState.cost * ratio)
            : taskState.cost * ratio;
        if (taskState.progress >= taskState.cost) {
            this._processingTasks.delete(taskName);
            this._endedTaskNames.add(taskName);
            this._endedTasksTotal += taskState.cost;
        }
        return true;
    }
    endTask(taskName) {
        const taskState = this._getTaskState(taskName);
        if (taskState === null)
            return;
        this._processingTasks.delete(taskName);
        this._endedTaskNames.add(taskName);
        this._endedTasksTotal += taskState.cost;
    }
    invokeProgressEvent() {
        if (this._onProgress === null)
            return;
        this._onProgress({
            lengthComputable: this.lengthComputable,
            loaded: this.loaded,
            total: this.total
        });
    }
    get loaded() {
        let loaded = this._endedTasksTotal;
        for (const [_taskName, task] of this._processingTasks) {
            loaded += task.progress;
        }
        return loaded;
    }
}
